import { on, reducer } from 'ts-action';
import { uniq } from 'lodash';
import * as autoLabelsActions from '../actions/auto-labels.actions';
import { Label, AssessmentStatus } from '../types/label';

declare module 'react-redux' {
  interface DefaultRootState {
    autoLabels: AutoLabelState;
  }
}

export interface AutoLabelState {
  labelsToAdd: Label[];
  labelsToRemove: Label[];
  status: AssessmentStatus;
  codeToAddSeenList: string[];
  codeToRemoveSeenList: string[];
}

const initialStateFactory = (): AutoLabelState => {
  return {
    labelsToAdd: [],
    labelsToRemove: [],
    status: 'none',
    codeToAddSeenList: [],
    codeToRemoveSeenList: [],
  };
};

export default reducer(
  initialStateFactory(),
  on(
    autoLabelsActions.setAutoLabels,
    (state, { labelsToAdd, labelsToRemove }): AutoLabelState => ({
      ...state,
      labelsToAdd,
      labelsToRemove,
      status: 'pending',
    }),
  ),
  on(
    autoLabelsActions.setAssessmentStatus,
    (state, { status }): AutoLabelState => ({
      ...state,
      status,
    }),
  ),
  on(
    autoLabelsActions.setCodeSeen,
    (state, { codeToAddSeen, codeToRemoveSeen }): AutoLabelState => ({
      ...state,
      codeToAddSeenList: uniq(state.codeToAddSeenList.concat(codeToAddSeen)),
      codeToRemoveSeenList: uniq(
        state.codeToRemoveSeenList.concat(codeToRemoveSeen),
      ),
    }),
  ),
  on(
    autoLabelsActions.toggleCodeAssessment,
    (state, { code }): AutoLabelState => ({
      ...state,
      labelsToAdd: state.labelsToAdd.map((label) =>
        label.code === code ? { ...label, status: !label.status } : label,
      ),
      labelsToRemove: state.labelsToRemove.map((label) =>
        label.code === code ? { ...label, status: !label.status } : label,
      ),
    }),
  ),
);
